<dz-block-alert *ngIf="showWarningBlockAlert" type="warning">
	<div dcrHTMLKey="PARTNER_PORTFOLIO_MARKET_VALUE_WARNING_BLOCK">The following portfolio(s) have had positions removed due to missing market value data:</div>
	<div *ngFor="let id of marketDataIssuesAccountIds">{{ id }}</div>
</dz-block-alert>
<dz-block-alert *ngIf="missingPortfolioDataIds.length" type="warning">
	<div dcrHTMLKey="PARTNER_PORTFOLIO_DATA_MISSING">The following portfolio(s) have been removed from analysis as there was an issue while fetching its data:</div>
	<div *ngFor="let id of missingPortfolioDataIds">{{ id }}</div>
</dz-block-alert>
<div class="dz-text-14" dcrHTMLKey="EDIT_PORTFOLIO_TEXT">You have the option to update the portfolio name before importing to 360&deg; Evaluator.</div>
<form [formGroup]="portfolioForm" *ngIf="portfolioForm">
	<dz-table [stickyHeaders]="true" [tableHeaders]="tableHeaders" [data]="this.portfolioForm.get('portfolios').controls">
		<tr dz-row *ngFor="let portfolio of this.portfolioForm.get('portfolios').controls; index as i" formArrayName="portfolios">
			<td dz-cell>
				<dz-form-field [ngClass]="{ 'no-error': !portfolio.get('invalidPortfolioInfo').get('hasError').value && !portfolio.get('portfolioDisplayName').errors }">
					<input
						type="text"
						[name]="portfolio.get('portfolioDisplayName').value + i.toString()"
						[id]="portfolio.get('portfolioDisplayName').value + i.toString()"
						[value]="portfolio.get('portfolioDisplayName').value"
						(input)="onPortfolioDisplayNameChange($event.target.value, i, portfolio.get('accountId').value)"
						[disabled]="portfolio.get('invalidPortfolioInfo').get('hasError').value"
						data-lpignore="true"
						dzInput
					/>
					<div *ngIf="!!portfolio.get('portfolioDisplayName').errors?.duplicateNameInImport" dcrHTMLKey="EDIT_PORTFOLIO_DUPLICATE_NAMES_IN_IMPORT" error>
						All portfolios must have unique names.
					</div>
					<div *ngIf="!!portfolio.get('portfolioDisplayName').errors?.modifiedDisplayNameHasErrors" dcrHTMLKey="EDIT_PORTFOLIO_EXISTING_NAME" error>
						You have a saved portfolio with this name.
					</div>
					<div *ngIf="!!portfolio.get('portfolioDisplayName').errors?.required" dcrHTMLKey="EDIT_PORTFOLIO_EMPTY_NAME" error>
						Please provide a name for this portfolio to proceed.
					</div>
					<div *ngIf="portfolio.get('invalidPortfolioInfo').get('hasError').value" [dcrHTMLKey]="portfolio.get('invalidPortfolioInfo').get('dcrKey').value" error>
						{{ portfolio.get('invalidPortfolioInfo').get('dcrValue').value }}
					</div>
				</dz-form-field>
			</td>
			<td dz-cell>
				{{ portfolio.get('accountId').value }}
			</td>
			<td dz-cell>
				{{ portfolio.get('platform').value }}
			</td>
			<td dz-cell class="text-bold">
				<span *ngIf="portfolio.get('enableRevert').value" class="clickable" (click)="handleRevertDisplayName(i, portfolio.get('accountId').value)">
					<dz-icon class="icon-color" type="undo"> </dz-icon> <span dcrHTMLKey="EDIT_PORTFOLIO_REVERT_BUTTON_TEXT">Revert</span>
				</span>
				<span class="pull-right"><dz-icon type="trash" class="icon-color clickable" (click)="deletePortfolio(i, portfolio.get('accountId').value)"></dz-icon></span>
			</td>
		</tr>
	</dz-table>
</form>
